<mat-card *ngIf="editContacteData" style="height:100%">
    <mat-toolbar style="width:100%">
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="deleteContacte()" matTooltip="Esborrar el contacte" aria-label="Esborrar el contacte" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">delete</mat-icon>
        </button>
        <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="addOrUpdate()" matTooltip="Desar el contacte" aria-label="Desar el contacte" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>
    <mat-card-content style="float:left;clear:both;padding: 24px">
      <h2 mat-line style="width:70%;color: black">Dades del contacte</h2>
      <div style="float:left;clear:none;margin-top:5px;margin-right:1em;width:50%">
        <mat-form-field style="width:100%">
          <input matInput type="text" (ngModelChange)="tbEmpreses = filterStates(editContacteData.empresa)"
           [(ngModel)]="editContacteData.empresa" name="empresa" 
            placeholder="Empresa"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let client of tbEmpreses" [value]="client.nom">{{client.nom}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div style="float:left;clear:none;margin-top:5px;width:25%">
        <mat-select style="width:100%" multiple="{{true}}" [(ngModel)]="ambit" [ngModelOptions]="{standalone: true}" placeholder="Àmbit">
          <mat-option value="Àfrica">Àfrica</mat-option>
          <mat-option value="Amèrica">Amèrica</mat-option>
          <mat-option value="Amèrica llatina">Amèrica llatina</mat-option>
          <mat-option value="Asia">Asia</mat-option>
          <mat-option value="Catalunya">Catalunya</mat-option>
          <mat-option value="Espanya">Espanya</mat-option>
          <mat-option value="Europa">Europa</mat-option>
          <mat-option value="Orient mitjà">Orient mitjà</mat-option>
        </mat-select>
      </div>
      <mat-form-field style="width: 55%">
        <input matInput placeholder="Nom" name="nom" [(ngModel)]="editContacteData.nom" ngDefaultControl />
      </mat-form-field>
      <mat-form-field style="width: 20%">
        <input matInput placeholder="Càrrec" name="tipus" [(ngModel)]="editContacteData.tipus" ngDefaultControl />
      </mat-form-field>
      <mat-form-field style="width: 55%">
       <input matInput placeholder="Adreça" name="adreca" [(ngModel)]="editContacteData.adreca" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 10%">
       <input matInput placeholder="Telèfon" name="tlf"
        [(ngModel)]="editContacteData.tlf" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 10%">
       <input matInput placeholder="Mòbil" name="mobil"
        [(ngModel)]="editContacteData.mobil" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 22%">
       <input matInput placeholder="E-correu" name="email"
        [(ngModel)]="editContacteData.email" ngDefaultControl/>
      </mat-form-field>
<!--      <mat-form-field style="width: 22%">
       <input matInput placeholder="Skype" name="skype"
        [(ngModel)]="editContacteData.skype" ngDefaultControl/>
      </mat-form-field>  -->
      <mat-form-field style="width: 30%">
       <input matInput placeholder="LinkedIn" name="linkedin"
        [(ngModel)]="editContacteData.linkedin" ngDefaultControl/>
      </mat-form-field>
      <div style="float:left;clear:both;margin-top:0px;width:100%">
        <mat-form-field style="width: 90%">
          <textarea matInput placeholder="Comentari" name="comentari" rows="3" [(ngModel)]="editContacteData.comentari"  style="width: 100%">
          </textarea>
        </mat-form-field> 
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%" *ngIf="editContacteData.id === 'NEW'">
        <mat-checkbox style="margin-right: 1em" placeholder="Definir com a professional" name="professional" [(ngModel)]="editContacteData.professional">Professional indepdendent</mat-checkbox>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%" *ngIf="error !== ''">
        <span style="color:red;font-weight: bold">{{error}}</span>
      </div>
    </mat-card-content>
</mat-card>
